// ФАЙЛ: translator.ts
// НАЗНАЧЕНИЕ: Построение i18n-контракта { t, locale } для overlay-плагинов.
//
// t(key, vars?) — чистый резолв по словарю: подстановка {{var}}-плейсхолдеров;
// если ключа нет — возвращается сам ключ (никогда не пусто, безопасно для UI).
// Плюрализацию плагин делает сам через Intl.PluralRules(i18n.locale), выбирая
// ключ вида overlay.votes.<category> и передавая его в t().

import type { PluginDict } from './store'

/** i18n-контракт, прокидываемый третьим пропом в компонент эффект-плагина. */
export interface PluginI18n {
  /** Резолв строки по ключу с подстановкой {{var}}. Fallback — сам ключ. */
  t: (key: string, vars?: Record<string, string | number>) => string
  /** Активная локаль (для Intl.PluralRules/NumberFormat внутри плагина). */
  locale: string
}

/** Подставляет {{name}} значениями из vars. Неизвестные плейсхолдеры не трогает. */
function interpolate(
  template: string,
  vars?: Record<string, string | number>,
): string {
  if (!vars) return template
  return template.replace(/\{\{(\w+)\}\}/g, (match, name: string) => {
    const value = vars[name]
    return value === undefined ? match : String(value)
  })
}

/** Собирает i18n-контракт для конкретного словаря/локали. */
export function createTranslator(locale: string, dict: PluginDict): PluginI18n {
  return {
    locale,
    t: (key, vars) => {
      const template = dict[key]
      return interpolate(
        typeof template === 'string' && template.length > 0 ? template : key,
        vars,
      )
    },
  }
}
